<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 238.49"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdLeft}"
            @click="select('thirdLeft')"
            d="M38.062 69.964c-5.488,1.563 -10.937,4.559 -16.347,8.988 5.41,-4.429 10.859,-7.425 16.347,-8.988zm22.394 8.604c-4.708,8.741 -11.275,14.537 -18.924,14.58 -7.8,0.045 -14.856,-5.424 -19.817,-14.196 -1.006,-1.777 -1.926,-3.691 -2.748,-5.722 -2.843,-7.023 -4.523,-15.449 -4.574,-24.515 -0.009,-1.456 0.013,-2.899 0.065,-4.325 8.084,0.617 15.795,0.074 23.131,-1.63 0.616,9.677 0.774,18.746 0.473,27.204 5.528,-1.575 11.096,-1.695 16.702,-0.361 2.794,0.665 5.598,1.691 8.412,3.078 -0.82,2.075 -1.728,4.046 -2.72,5.887z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M60.456 78.568c-4.708,8.741 -11.275,14.537 -18.924,14.58 -7.8,0.045 -14.856,-5.424 -19.817,-14.196 5.41,-4.429 10.859,-7.425 16.347,-8.988 5.528,-1.575 11.096,-1.695 16.702,-0.361 2.794,0.665 5.598,1.691 8.412,3.078 -0.82,2.075 -1.728,4.046 -2.72,5.887z"
        />

        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthLeft}"
            @click="select('fourthLeft')"
            d="M37.589 42.76c-7.336,1.704 -15.047,2.247 -23.131,1.63 0.695,-19.036 6.795,-35.139 18.892,-39.364 2.082,13.468 3.494,26.045 4.239,37.734z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdRight}"
            @click="select('thirdRight')"
            d="M54.764 69.603c-2.269,-7.174 -3.748,-16.077 -4.457,-26.565 6.614,-0.257 12.676,-0.674 18.184,-1.252 -0.102,2.212 -0.235,4.436 -0.332,6.62 -0.379,8.618 -2.142,17.075 -4.983,24.275 -2.814,-1.387 -5.618,-2.413 -8.412,-3.078z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthRight}"
            @click="select('fourthRight')"
            d="M68.491 41.786c-5.508,0.578 -11.57,0.995 -18.184,1.252 -0.719,-10.653 -0.644,-22.943 0.209,-36.72 6.774,3.027 13.123,8.929 16.399,17.587 1.911,5.052 1.875,11.421 1.576,17.881z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M38.062 69.964c0.301,-8.458 0.143,-17.527 -0.473,-27.204 -0.745,-11.689 -2.157,-24.266 -4.239,-37.734 2.332,-0.814 4.888,-1.187 7.67,-1.054 3.078,0.146 6.334,0.933 9.496,2.346 -0.853,13.777 -0.928,26.067 -0.209,36.72 0.709,10.488 2.188,19.391 4.457,26.565 -5.606,-1.334 -11.174,-1.214 -16.702,0.361z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M18.967 73.23c0.585,69.968 4.548,117.637 11.889,143.007 9.615,18.799 17.276,0.849 16.094,-57.301 -0.533,-19.16 4.356,-45.949 13.506,-80.368m-46.063 -29.853c-0.142,-24.626 8.331,-45.616 26.627,-44.743 9.669,0.461 21.089,7.231 25.895,19.933 2.566,6.782 1.622,15.939 1.244,24.501 -1.008,22.9 -11.78,44.658 -26.627,44.742 -14.848,0.085 -26.999,-19.808 -27.139,-44.433z"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.root}"
            @click="select('root')"
            cx="43.23"
            cy="103.275"
            r="9.965"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            cx="44.764"
            cy="224.774"
            r="9.965"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
